import { createSlice } from "@reduxjs/toolkit";
import { Usersignup, Userlogin, fetchuserAds, fetchCartItems, UserEdit, getStates } from "./UserAction";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const initialState = {
    userInfo: {
        _id: "",
        name: "",
        email: "",
        contact: '',
        ads: {
            pending: [],
            approved: [],
            negotiation: [],
            sold: []
        },
        location: '',
        shippingAddress: {
            streetAddress: '',
            city: '',
            state: '',
            pincode: ''
        },
    },
    error: null,
    loading: false,
    success: false,
    token: null,

    cart: []
}


export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        logout: (state) => {
            state.userInfo = null
            state.error = null
            state.loading = false
            state.success = false
            state.token = null
            cookies.remove("token")
        },
        saveAddress: (state, action) => {
            state.userInfo.shippingAddress = action.payload
        }
    },
    extraReducers: (builder) => {
        //userSignup Pending Fulfilled Rejected
        builder.addCase(Usersignup.pending, (state, action) => {
            state.loading = true
            state.error = false
        })
        builder.addCase(Usersignup.fulfilled, (state, { payload }) => {
            state.loading = false
            state.success = true // registration successful
            state.userInfo = payload.userData 
            state.token = payload.token
        })
        builder.addCase(Usersignup.rejected, (state, { payload }) => {
            state.loading = false
            state.error = payload
        })

        //userLogin Pending Fulfilled Rejected
        builder.addCase(Userlogin.pending, (state, action) => {
            state.loading = true
            state.error = false
        })
        builder.addCase(Userlogin.fulfilled, (state, { payload }) => {
            console.log(payload)
            state.loading = false
            state.success = true // registration successful
            state.userInfo = payload.userData
            state.token = payload.token
        })
        builder.addCase(Userlogin.rejected, (state, { payload }) => {
            state.loading = false
            state.error = payload
        })

        //fetchuserAds Pending Fulfilled Rejected
        builder.addCase(fetchuserAds.pending, (state, action) => {
            state.loading = true
            state.error = false
        })
        builder.addCase(fetchuserAds.fulfilled, (state, { payload }) => {
            state.loading = false
            state.success = true // registration successful
            state.userInfo.ads = payload.ads
            console.log("User ads fetched sucesssful", payload.ads)
        })
        builder.addCase(fetchuserAds.rejected, (state, { payload }) => {
            state.loading = false
            state.error = payload
        })

        // fetch User cart items
        builder.addCase(fetchCartItems.pending, (state, action) => {
            state.loading = true
            state.error = false
        })
        builder.addCase(fetchCartItems.fulfilled, (state, { payload }) => {
            state.loading = false
            state.success = true // registration successful
            state.cart = payload.items

            console.log("User cart items fetched sucesssful", payload)
        })
        builder.addCase(fetchCartItems.rejected, (state, { payload }) => {
            state.loading = false
            state.error = payload
        })

        // storing user shipping adrress
        builder.addCase(UserEdit.pending, (state, action) => {
            state.loading = true
            state.error = false
        })
        builder.addCase(UserEdit.fulfilled, (state, { payload }) => {
            // console.log(payload)
            state.loading = false
            state.success = true // registration successful
            state.userInfo = payload.userData
            state.token = payload.token
        })
        builder.addCase(UserEdit.rejected, (state, { payload }) => {
            console.log(payload)
            state.loading = false
            state.error = payload
        })
    },
})

export default userSlice.reducer
export const { logout, saveAddress } = userSlice.actions